
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useNotificationsManager } from './use-notifications-manager';

export const useRealtimeNotifications = () => {
  // Use the consolidated notifications manager
  const notificationsManager = useNotificationsManager();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    // Check authentication before trying to subscribe
    const checkAuthentication = async () => {
      try {
        const { data } = await supabase.auth.getUser();
        if (!data?.user) {
          console.log("User not authenticated, skipping realtime subscriptions");
          setIsAuthenticated(false);
          return;
        }
        
        console.log("User authenticated, realtime subscriptions ready");
        setIsAuthenticated(true);
      } catch (error) {
        console.error("Error checking authentication:", error);
        setIsAuthenticated(false);
      }
    };
    
    checkAuthentication();
    
    // Clean up function
    return () => {
      console.log("Realtime notifications cleanup");
    };
  }, [notificationsManager]);

  return { isAuthenticated };
};
